module.exports = __webpack_public_path__ + "static/media/planlegge.457594a3.m4a";